import builder from '../builder';
import SignBadgeCircle from '../../streamline-icons/bold/sign-badge-circle.svg';

export default builder('IconSignBadgeCircleBold', SignBadgeCircle);
